import { Reveal } from "@/components/Reveal";
import { Sprout, HeartPulse, Scale, Dumbbell, Trophy } from "lucide-react";
import { GreekWatermark } from "@/components/GreekWatermark";

const SEGMENTS = [
  {
    icon: Sprout,
    title: "Complete Beginners",
    desc: "Never lifted before? Every movement is taught from the ground up, coached and scaled to you.",
  },
  {
    icon: HeartPulse,
    title: "Everyday Fitness",
    desc: "Build strength and energy for real life, with coached sessions that fit around your week.",
  },
  {
    icon: Scale,
    title: "Weight Loss",
    desc: "Structured programming and a community that keeps you consistent when motivation dips.",
  },
  {
    icon: Dumbbell,
    title: "Strength & Performance",
    desc: "Chase real numbers with technical coaching on the barbell and beyond.",
  },
  {
    icon: Trophy,
    title: "Competitive Athletes",
    desc: "Individualised programming and coaching for athletes training for the competition floor.",
  },
];

export function IsItForMe() {
  return (
    <section className="bg-surface border-y border-line py-24 sm:py-32 relative overflow-hidden" data-testid="is-it-for-me-section">
      <GreekWatermark letter="Β" className="top-0 right-0 sm:right-10" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <Reveal className="text-center max-w-2xl mx-auto">
          <p className="eyebrow mb-3">Built around you</p>
          <h2 className="font-anton uppercase tracking-tighter text-cream text-4xl sm:text-5xl">Is Elysium for me?</h2>
          <p className="text-smoke mt-4">
            Whether you are starting from scratch or chasing your next performance goal, there is a place for you here.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 mt-14">
          {SEGMENTS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06}>
              <div className="border border-line hover:border-gold/50 transition-colors p-6 h-full bg-void" data-testid={`is-it-for-me-segment-${i}`}>
                <s.icon className="h-7 w-7 text-gold mb-4" />
                <h3 className="font-anton uppercase text-cream text-lg mb-2 leading-tight">{s.title}</h3>
                <p className="text-smoke text-sm leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
